import { AtemApplication } from "../../modules/user/domain/constants";
import { applicationListRules, CurrentApplication } from "../../utils";
import LoginDefault from "./LoginDefault";
import LoginIdpPage from "./LoginIdp";
import LoginNotPortalPage from "./LoginNotPortal";
import LoginTrading from "./LoginTrading";

function Login() {
  switch (CurrentApplication()) {
    case AtemApplication.IDP:
      return <LoginIdpPage />;
    case AtemApplication.CHECKLIST:
    case AtemApplication.SUPPLY_CHAIN:
    case AtemApplication.SALES_PORTAL:
    case AtemApplication.LOADING:
    case AtemApplication.SALES:
      return <LoginNotPortalPage />;
    case applicationListRules.PORTAL_TRADING:
      return <LoginTrading />;
    default:
      return <LoginDefault />;
  }
}

export default Login;
